import Typography from '@mui/material/Typography';
import React from 'react';

import { useTranslator } from '@/hooks/useTranslator';

export const PasswordRules: React.FC = (): React.ReactElement => {
  const tr = useTranslator();

  return (
    <Typography variant="caption" color="text.secondary" lineHeight="26px">
      {tr('PASSWORD_MINIMUM')}{' '}
      <Typography variant="caption" component="span" color="primary">
        {tr('EIGHT_CHARACTERS')}
      </Typography>
      {tr('COMMA_ONE')}
      <Typography variant="caption" component="span" color="primary">
        {' '}
        {tr('SPECIAL_CHARACTER')}
      </Typography>
      {tr('COMMA_AND_ONE')}{' '}
      <Typography variant="caption" component="span" color="primary">
        {tr('NUMBER')}
      </Typography>
      .
    </Typography>
  );
};
